module.exports = "<!DOCTYPE html>"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/user-list.component.pug
// module id = 1648
// module chunks = 0